import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home/home"),
  },
  {
    path: "/shop",
    name: "shop",
    component: () => import("../views/shop/shop"),
  },
  {
    path: "/selection",
    name: "selection",
    component: () => import("../views/selection/index"),
  },
  {
    path: "/shopDetail",
    name: "shopDetail",
    component: () => import("../views/shop/shopDetail"),
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("../views/cart/cart"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/system/login"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/system/register"),
  },
  {
    path: "/agreement",
    name: "agreement",
    component: () => import("../views/system/agreement"),
  },
  {
    path: "/qAndA",
    name: "qAndA",
    component: () => import("../views/qAndA/qAndA"),
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("../views/aboutUs/aboutUs"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/contact/contact"),
  },
  {
    path: "/resetPassword",
    name: "resetPassword",
    component: () => import("../views/system/resetPassword"),
  },
  {
    path: "/payOrder",
    name: "payOrder",
    component: () => import("../views/order/payOrder"),
  },
  {
    path: "/order",
    name: "order",
    component: () => import("../views/order/order"),
  },
  //汽配嘉年华
  {
    path: "/qpjnh",
    name: "qpjnh",
    component: () => import("../views/qpjnh/qpjnh"),
  },
  {
    path: "/booking",
    name: "booking",
    component: () => import("../views/qpjnh/booking"),
  },
  {
    path: "/subapply",
    name: "subapply",
    component: () => import("../views/qpjnh/subapply"),
  },
  //汽配港头条
  {
    path: "/qpgtt",
    name: "qpgtt",
    component: () => import("../views/qpgtt/qpgtt"),
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import("../views/qpgtt/newsDetail"),
  },
  //企业库
  {
    path: "/company",
    name: "company",
    component: () => import("../views/company/company"),
  },
  //企业库
  {
    path: "/company_exponent",
    name: "company_exponent",
    component: () => import("../views/company/company_exponent"),
  },
  //宣传页
  {
    path: "/promotional",
    name: "promotional",
    component: () => import("../views/promotional/promotional.vue"),
  },
  {
    path: "/companyDetail",
    name: "companyDetail",
    component: () => import("../views/company/companyDetail"),
  },
  // 商机
  {
    path: "/business",
    name: "business",
    component: () => import("../views/Business/business"),
  },
  // 发布商机
  {
    path: "/businees_publish",
    name: "Businees_publish",
    component: () => import("../views/Businees_publish/businees_publish"),
  },
  // 我的
  {
    path: "/my",
    name: "my",
    component: () => import("../views/my/my"),
    children: [
      {
        path: '/my/my_businees_publish',
        name: 'my_businees_publish',
        component: () => import("../views/my/components/my_businees_publish.vue")
      },
      {
        path: '/my/my_product',
        name: 'my_product',
        component: () => import("../views/my/components/my_product.vue")
      },
      {
        path: '/my/comingsoon',
        name: 'my_businees_publish',
        component: () => import("../views/my/components/comingsoon.vue")
      }

    ]
  },

  // 注册协议
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () => import("../components/agreement/privacyPolicy.vue"),
  },
];

const router = new VueRouter({
  routes,
});
// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.name == 'login' || to.name == 'register') {
    const isAuthenticated = localStorage.getItem('token');
    if (isAuthenticated) {
      next(from.name);
    } else {
      next(); // 允许路由跳转
    }
  } else {
    next(); // 无需验证，直接跳转
  }
});
export default router;
